import classNames from "classnames";
import { forwardRef } from "react";

import { FieldGroupAppend as StyledAppend } from "../FieldGroup.styled";
import { FieldGroupProps } from "../";

const FieldGroupAppend = forwardRef<HTMLDivElement, FieldGroupProps>((props, ref) => {
  const { className, ...restProps } = props;
  const fieldGroupAppendClass = classNames("c-field-group__append", className);

  return (
    <StyledAppend data-testid="qa-field-group-append" ref={ref} className={fieldGroupAppendClass} {...restProps} />
  );
});

export default FieldGroupAppend;
